import PropTypes from "prop-types";
import { SmileOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import "./chatReactions.scss";

const ChatReactionButton = ({ active = false, onClick, className = "" }) => {
  const { t } = useTranslation("common");
  return (
    <button
      type="button"
      className={`chat-reaction-btn${active ? " is-active" : ""} ${className}`.trim()}
      aria-label={t("chatMessages.react", "React")}
      title={t("chatMessages.react", "React")}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.(e);
      }}
    >
      <SmileOutlined />
    </button>
  );
};

ChatReactionButton.propTypes = {
  active: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

export default ChatReactionButton;
